/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementListResponse } from '../../models/agreement-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AgreementsControllerGetAll$Params {
  parent_agreement_id?: number;
  product_category_id?: number;
  identifier?: string;
  active?: boolean;
  name?: string;
  lot?: string;
  description?: string;
  from_date?: string;
  to_date?: string;
  duration?: number;
  related_subject_id?: number;
  agreement_type_id?: number;
  related_emitting_registry_id?: Array<number>;
  related_attendee_registry_id?: Array<number>;
  related_maintenance_registry_id?: Array<number>;
  limit: number;
  skip: number;
  related_order_status_workflow_id?: number;
  related_ticket_status_workflow_id?: number;
  show_only_parents_agreements?: boolean;
  order_by?: string;
  order_direction?: string;
}

export function agreementsControllerGetAll(http: HttpClient, rootUrl: string, params: AgreementsControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('parent_agreement_id', params.parent_agreement_id, {});
    rb.query('product_category_id', params.product_category_id, {});
    rb.query('identifier', params.identifier, {});
    rb.query('active', params.active, {});
    rb.query('name', params.name, {});
    rb.query('lot', params.lot, {});
    rb.query('description', params.description, {});
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('duration', params.duration, {});
    rb.query('related_subject_id', params.related_subject_id, {});
    rb.query('agreement_type_id', params.agreement_type_id, {});
    rb.query('related_emitting_registry_id', params.related_emitting_registry_id, {});
    rb.query('related_attendee_registry_id', params.related_attendee_registry_id, {});
    rb.query('related_maintenance_registry_id', params.related_maintenance_registry_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('related_order_status_workflow_id', params.related_order_status_workflow_id, {});
    rb.query('related_ticket_status_workflow_id', params.related_ticket_status_workflow_id, {});
    rb.query('show_only_parents_agreements', params.show_only_parents_agreements, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AgreementListResponse;
      }>;
    })
  );
}

agreementsControllerGetAll.PATH = '/agreements';
